import { render } from "./IsoInChangeFork.vue?vue&type=template&id=062167e6"
import script from "./IsoInChangeFork.vue?vue&type=script&lang=js"
export * from "./IsoInChangeFork.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__